import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ConfigProvider } from './contexts/ConfigContext';
import { ModeProvider } from './contexts/ModeContext';
import { loadConfig, applyThemeColors } from './services/configService';
import { BackendConfig, DEFAULT_BACKEND_CONFIG } from './types/config';
import './App.css';
import LoadingScreen from './components/LoadingScreen';
import C1SignupFlow from './components/C1Signup/C1SignupFlow';

function App() {
  const [config, setConfig] = useState<BackendConfig | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const initializeApp = async () => {
      try {
        setIsLoading(true);
        setError(null);

        const loadedConfig = await loadConfig();
        setConfig(loadedConfig);
        applyThemeColors(loadedConfig);

      } catch (err) {
        const errorMsg = err instanceof Error ? err.message : 'Failed to load configuration';
        setError(errorMsg);
        setConfig(DEFAULT_BACKEND_CONFIG);
        applyThemeColors(DEFAULT_BACKEND_CONFIG);
      } finally {
        setIsLoading(false);
      }
    };

    initializeApp();
  }, []);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <ModeProvider>
      <ConfigProvider config={config} isLoading={isLoading} error={error}>
        <ErrorBoundary>
          <Router>
            <Routes>
              <Route path="/signup" element={<C1SignupFlow />} />
              <Route path="/" element={<Navigate to="/signup" replace />} />
              <Route path="*" element={<Navigate to="/signup" replace />} />
            </Routes>
          </Router>
        </ErrorBoundary>
      </ConfigProvider>
    </ModeProvider>
  );
}

export default App;
